import { TargetNodeType } from "@p0security/shared/types/assessment/data/index";
import { assertNever } from "@p0security/shared/types/index";
import { Button, Flex } from "@p0security/ui";
import { useCallback, useMemo } from "react";

export type HasAddTerm = {
  terms: string | undefined;
  show?: TargetNodeType;
  onAddTerm: (term: string) => void;
};

const AddTerm: React.FC<
  HasAddTerm & {
    mode: "hide" | "only" | "show";
    name?: string;
    term: string;
  }
> = ({ mode, name, term, terms, onAddTerm }) => {
  const updateTerm = useMemo(
    () =>
      mode === "show"
        ? term
        : term.startsWith("^")
          ? term.slice(1)
          : `^${term}`,
    [mode, term]
  );
  const onClick = useCallback(
    () => onAddTerm(updateTerm),
    [onAddTerm, updateTerm]
  );
  return (
    <Button
      size="small"
      className="text-left text-[13px]"
      type="link"
      onClick={onClick}
      disabled={!!terms?.split(" ").find((t) => t === updateTerm)}
    >
      {mode === "show"
        ? "\u2795 Show"
        : mode === "hide"
          ? "\u2796 Hide"
          : mode === "only"
            ? "\u2797 Show only"
            : assertNever(mode)}{" "}
      {name ?? "items"} like this
    </Button>
  );
};

export const ShowHideTerm: React.FC<
  HasAddTerm & {
    inverse?: string;
    term: string;
    name?: string;
  }
> = (props) => (
  <Flex align="start" justify="flex-start" vertical>
    <AddTerm mode="show" {...props} />
    <AddTerm mode="hide" {...props} />
    {props.inverse && <AddTerm mode="only" {...props} term={props.inverse} />}
  </Flex>
);
